// Único usuario admin master del panel de control (ver también App.vue, AppSidebarAdmin.vue,
// Panel.vue y Sucursales.vue). Este usuario siempre tiene acceso total, sin importar el rol
// que tenga asignado en Panel_Roles.
export const ADMIN_MASTER_ID = 'DzFeyylmESMWe8oCRal51vs9Tzt2';

export const ROL_MASTER_OBJ = {
  info: { nombre: 'Admin master' },
  modulos: {
    clientes: {
      accesos: true,
      informacion: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true,
        cambiar_password: true
      }
    },
    sucursales: {
      accesos: true,
      informacion: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true
      }
    },
    empleados: {
      accesos: true,
      informacion: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true
      }
    },
    roles: {
      accesos: true,
      informacion: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true,
      }
    },
  }
}

export const ROL_BASE_OBJ = {
  info: { nombre: '' },
  modulos: { 
    clientes: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false,
        cambiar_password: false
      }
    },
    sucursales: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    empleados: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    roles: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false,
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/constantes/panel_roles.js